import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Alert, DatePicker, Form, Input } from 'antd'
import dayjs from 'dayjs'
import { useEffect } from 'react'
import { selectSelectedFeaturedVenues } from '../../../store/FeaturedVenuesReducer'
import { useAppSelector } from '../../../store/hooks'
import { requiredRule } from '../../../utils/rules'
import { Localizable } from '../../localizable/Localizable'
import { disabledDate } from './Create'

const { RangePicker } = DatePicker

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedFeaturedVenues())
  useEffect(() => {
    if (item?.startDate && item?.endDate) {
      form.setFieldsValue({
        dates: [dayjs(item.startDate), dayjs(item.endDate)],
      })
    }
  }, [item, form])

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden style={{ display: 'none' }} rules={[]}>
        <Input type="hidden" />
      </Form.Item>
      <Localizable.Input
        name="title"
        rules={[requiredRule()]}
        label={'Title'}
        max={45}
      />
      <Form.Item name="dates" rules={[]} label={'Dates'}>
        <RangePicker className="w-full" disabledDate={disabledDate} />
      </Form.Item>

      <Form.Item name="venues" rules={[requiredRule()]} label={'Venues'}>
        <SBAsyncSelect
          entity={Entity.venue}
          searchFieldName="name"
          allowClear
          multiple
        />
      </Form.Item>

      <Alert
        title="Warning: Please ensure the selected date range does not overlap with an existing one."
        type="warning"
        showIcon
      />
    </Form>
  )
}

export default Update
